import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AddressFormGroup } from '../shared/models';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'app-address',
    imports: [
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule
],
    templateUrl: './address.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './address.component.scss'
})
export class AddressComponent {
  @Input() addressFormGroup!: FormGroup<AddressFormGroup>;
}
